const initPreloader = () => {
  const preloader = document.querySelector('.preloader');

  if (!preloader) {
    return;
  }

  document.body.classList.add('is-loaded');
  const intro = document.querySelector('.intro');

  if (!preloader.classList.contains('is-hide')) {
    setTimeout(() => {
      preloader.classList.add('is-hidden');
    }, 1500);

    setTimeout(() => {
      if (intro) {
        intro.classList.add('is-show-intro');
      }
    }, 2000);
  } else {
    intro.classList.add('is-show-intro');
  }
};

export {initPreloader};
